import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PercentageSlider } from '../../../components/percentageSlider';

export const HomeSectionCompetencies = props => (
  <div className='check-list color-purple'>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div
          className='check-list-item-index check-list-item-index--enormous'>
          <FontAwesomeIcon icon={['fas', 'list']}/>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <h2 className='uppercase'>Other competencies</h2>
        <p/>
      </div>
    </div>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div className='check-list-item-index'>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <p className='title'>
          <b>Languages</b>
        </p>
        <p><b>English</b>: advanced conversational and written english</p>
        <PercentageSlider percentage={70} darken width={40}/>
        <p><b>Russian</b>: native</p>
        <PercentageSlider percentage={100} darken width={40}/>
      </div>
    </div>
    <div className='check-list-item'>
      <div className='check-list-item-progress'>
        <div className='check-list-item-index'>
        </div>
        <div className='check-list-item-sep'>
        </div>
      </div>
      <div className='check-list-item-body'>
        <p className='title'>
          <b>Development</b>
        </p>
        <p>Developing high performance and high load applications.</p>
        <p>Experienced with relational and document-oriented databases.</p>
        <p>Experienced with client side libraries: angular.js, react.js, vue.js, jQuery and others.</p>
        <p>Experienced with HTML, CSS, JavaScript.</p>
        <p>Experienced with Agile/Scrum methodology.</p>
        <p>Experienced with API design.</p>
        <p>Experienced with Android Application development.</p>
        <p>Experienced with resolving technical problems.</p>
        <p>Experienced with writing a technical assignment.</p>
      </div>
    </div>
  </div>
);
